import { App, AppBody, Bootstrap, MadeThisNextPage } from "made-this-ui";
import Head from "next/head";
import { AppProps } from "next/app";
import themeAdmin from "admin/lib/theme";

import { Center, CircularProgress } from "@chakra-ui/react";
import { AppRedirect } from "common/AppRedirect";
import {
  CurrentUserFragmentType,
  useCurrentUser,
} from "service/lib/useCurrentUser_Service";
import { useLocaleRedirect } from "admin/lib/useLocaleRedirect";

export type ServiceAppProps = {};

export const ServiceApp = ({ Component, pageProps }: AppProps) => {
  return (
    <Bootstrap
      theme={themeAdmin}
      graphqlOptions={{ endpoint: "/admin/graphql/admin" }}
    >
      <Head>
        <title>Ejsingholm / Service</title>
      </Head>
      <DataLoader Component={Component} pageProps={pageProps} />
    </Bootstrap>
  );
};

type DataLoaderProps = {
  Component: MadeThisNextPage<{
    user?: CurrentUserFragmentType;
  }>;
  pageProps: AppProps["pageProps"];
};
function DataLoader({ Component, pageProps }: DataLoaderProps) {
  const currentUser = useCurrentUser();

  useLocaleRedirect(currentUser?.locale);

  if (currentUser === undefined) {
    return (
      <Center h="100vh">
        <CircularProgress color="primary.400" isIndeterminate />
      </Center>
    );
  }

  if (currentUser === null) {
    return <AppRedirect path="/authorize" includeReturnTo />;
  }

  if (!currentUser.isServiceAdministrator && !currentUser.isServiceCaseWorker) {
    return <DetermineNextPage currentUser={currentUser} />;
  }

  return (
    <App>
      <AppBody>
        <Component {...pageProps} user={currentUser} />
      </AppBody>
    </App>
  );
}

function DetermineNextPage({
  currentUser,
}: {
  currentUser: CurrentUserFragmentType;
}) {
  if (!currentUser.isSystemAdministrator && !currentUser.isAdministrator) {
    return <AppRedirect path={"/home"} />;
  }

  return <AppRedirect path={"/next/admin"} />;
}
